// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-635316e5]{font-weight:600;white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
